import * as PropTypes from 'prop-types';

var OptionGroup = PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.string
});
var OptionType = PropTypes.shape({
  key: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  group: PropTypes.oneOfType([OptionGroup, PropTypes.string])
});
PropTypes.shape({
  key: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool
});

export { OptionGroup, OptionType };
//# sourceMappingURL=SelectTypes.js.map
